import { render } from "./DiscussionV1.vue?vue&type=template&id=aefaf428&scoped=true"
import script from "./DiscussionV1.vue?vue&type=script&lang=js"
export * from "./DiscussionV1.vue?vue&type=script&lang=js"

import "./DiscussionV1.vue?vue&type=style&index=0&id=aefaf428&lang=sass&scoped=true"
import "./DiscussionV1.vue?vue&type=style&index=1&id=aefaf428&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aefaf428"]])

export default __exports__